<mat-toolbar class="switchRole" *ngIf="switchedRole && switchRoleAvailable">
  <p class="text">Vous visualisez actuellement l'application en tant que {{ switchedRole }}</p>
  <div class="view-management">
    <p class="text">Fin de session dans {{ sessionMinute }}min{{ sessionSeconde }}</p>
    <button mat-icon-button aria-label="Quitter la visualisation" matTooltip="Quitter la visualisation" (click)="exitRoleView(true)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>
<mat-toolbar [ngClass]="[switchedRole ? 'switched' : '']" class="navbar" color="primary">
  <button mat-icon-button (click)="toggleDrawer()" data-testid="menu-button">
    <mat-icon>menu</mat-icon>
  </button>
  <img class="logo-app" src="{{ srcLogo }}" alt="logo application" />
  <span class="title">{{ titre }}{{ environment.env_name !== 'prod' ? ' [' + environment.env_name.toUpperCase() + ']' : '' }}</span>
  <span class="toolbar-spacer"></span>

  <button mat-icon-button aria-label="Changer de rôle" matTooltip="Changer de rôle" (click)="openSwitchRole()" *ngIf="switchRoleAvailable">
    <mat-icon>change_circle</mat-icon>
  </button>
  <app-profil></app-profil>
</mat-toolbar>

<mat-sidenav-container class="sidenav-container" [ngClass]="[switchedRole ? 'switched' : '']" data-testid="sidenav-container">
  <mat-sidenav class="sidenav bg-primary darkMode" mode="side" [opened]="isMenuOpen">
    <app-menu-navigation></app-menu-navigation>
    <div class="footer">
      <img class="logo-dpt" src="{{ srcLogoDepartement }}" alt="logo departement 77" />
      <div
        class="version-app clickable-version"
        data-testid="version-app"
        (click)="afficherNotesDeVersion()"
        matTooltip="Voir les notes de version"
        matTooltipPosition="above">
        Version {{ numVersionApp }}
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="blueMode">
    <div class="main">
      <app-breadcrumb></app-breadcrumb>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
